import * as yup from "yup";
// TODO change file name to schema

export const schemaEmail = yup.object({
  email: yup.string().email("Invalid email").required("Please enter a valid email address"),
});

export const schemaCreatePassword = yup.object({
  password: yup
    .string()
    .required("The password is incorrect. Please try another one")
    .test(
      "password-strength",
      "Password must be at least 8 characters and include 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character",
      (value) =>
        !!value &&
        value.length >= 8 &&
        /[a-z]/.test(value) &&
        /[A-Z]/.test(value) &&
        /\d/.test(value) &&
        /[!@#$%^&*(),.?":{}|<>]/.test(value)
    ),

  confirmPassword: yup
    .string()
    .required("Confirm Password is required")
    .oneOf([yup.ref("password")], "Passwords did not match. Please check again"),
});

export const schemaCreateUsername = yup.object({
  username: yup
    .string()
    .min(4, "User must be at least 4 characters")
    .max(30, "Username must be at most 30 characters")
    .matches(
      /^[a-zA-Z0-9._]+$/,
      "Username can only contain letters, numbers, periods and underscores"
    )
    .required("Please enter username"),
});

export const schemaMoreInformation = yup.object({
  // avatar: yup.,
  // bio: yup.string().required("Bio is required").min(3, "Bio must be at least 3 characters"),
});
